module.exports = __webpack_public_path__ + "static/media/IMG_4310.66e22c37.JPG";